<template>
  <div class="home">
    <div class="dashboard">
      <el-row :gutter="20" style="margin-left: 0; margin-right: 0;">
        <el-col :span="8">
          <div class="grid-content bg_lightblue">
            <div class="grid-title size-18 white">
              <i class="iconfont icon-zhaobiao size-18" />
              {{ $t("home_pageText.TENDERTOTAL") }}
            </div>
            <div class="grid-value size-45 white content_over">3000</div>
            <i class="iconfont icon-zhaobiao grid-bg" />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg_lightgreen">
            <div class="grid-title size-18 white">
              <i class="iconfont icon-zhaobiao1 size-18" />
              {{ $t("home_pageText.WINBIDTOTAL") }}
            </div>
            <div class="grid-value size-45 white content_over">1000</div>
            <i class="iconfont icon-zhaobiao1 grid-bg" />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg_orange">
            <div class="grid-title size-18 white">
              <i class="iconfont icon-zhaobiao2 size-18" />
              {{ $t("home_pageText.CANBIDTOTAL") }}
            </div>
            <div class="grid-value size-45 white content_over">1000</div>
            <i class="iconfont icon-zhaobiao2 grid-bg" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="listbox">
      <el-row :gutter="20" style="margin-left: 0; margin-right: 0;">
        <el-col :sm="24" :md="12">
          <div class="list-content bg_white">
            <div class="list-title size-18 white">
              <i class="iconfont icon-icon" />
              {{ $t("home_pageText.NOBIDLIST") }}
              <div class="list-more size-14 white">
                {{ $t("common_pageText.LISTMORE") }}
              </div>
            </div>
            <div class="list-info">
              <div class="list-item content_over size-16">哈哈哈</div>
              <div class="list-item content_over size-16">哈哈哈</div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="list-content bg_white">
            <div class="list-title size-18 white">
              <i class="iconfont icon-icon" />
              {{ $t("home_pageText.BIDEDLIST") }}
              <div class="list-more size-14 white">
                {{ $t("common_pageText.LISTMORE") }}
              </div>
            </div>
            <div class="list-info">
              <div class="list-item content_over size-16">hahaha</div>
              <div class="list-item content_over size-16">hahaha</div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
              <div class="list-item content_over size-16"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  mounted() {},
  methods: {
    init() {}
  }
};
</script>
<style scoped>
.home {
}
.dashboard {
  min-width: 1000px;
  padding: 20px 0;
  /* text-align: center; */
}
.el-col {
  border-radius: 4px;
}
.listbox > .el-row > .el-col {
  padding-bottom: 20px;
}
.grid-content {
  height: 200px;
  padding: 30px 10px 30px 30px;
  border-radius: 5px;
  box-shadow: 5px 5px 5px #ddd;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
.grid-title {
  height: 90px;
}
.grid-value {
  font-weight: 600;
}
.grid-bg {
  margin-right: -10%;
  position: absolute;
  right: 0;
  bottom: 0;
  color: rgba(255, 255, 255, 0.3);
  font-size: 12em;
}
.list-content {
  height: 455px;
  border: 2px solid #666;
  border-radius: 3px;
}
.list-title {
  height: 45px;
  line-height: 45px;
  padding: 0 5px;
  background-color: #666;
}
.list-info {
  max-height: 420px;
  padding: 0 10px;
}
.list-item {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px dotted #ddd;
}
.list-more {
  display: inline;
  padding: 0 10px;
  text-align: right;
}
</style>

